//helper
import Account from '@/helper/AccountHelper.js';
import Locale from "@/helper/locale/locale.js";
//core
import { CallbackEvent } from "@/core/Utility/CallbackEvent.js";
//service
import BzbsEarnPoint from "@/core/History/service/BzbsEarnPoint.js";
export function EarnPointController () {
    this.lbl = Locale.getLbl();
    //page
    this.isLoaded = false;
    this.isLoading = false;
    this.isHaveItem = false;
    this.isHaveMore = true;
    this.listConfigBuilder = null;
    //list
    this.list = [];
    //modal
    this.modalController = null;
    //callback event
    this.cbGetListSuccess = new CallbackEvent();
    this.cbApiResponseError = new CallbackEvent();

    this.initialList = function (listConfigBuilder, controller) {
        this.listConfigBuilder = listConfigBuilder;
        this.modalController = controller;
        this.getList();
    };
    this.getList = function () {
        if (this.showLoading()) return;

        var token = Account.getToken();
        var params = this.listConfigBuilder
                    .create()
                    .getParams();
        BzbsEarnPoint.apiGetPointHistory(token, params)
            .then(res => {
                if (res.data
                    && res.data.length < 25) {
                    this.isHaveMore = false;
                }

                for (var point of res.data) {
                    //TODO: Add GA Tracking.
                    this.list.push(point);
                }

                if (this.list.length > 0) {
                    this.isHaveItem = true;
                    this.listConfigBuilder = this.listConfigBuilder.setLastRowKey(this.list[this.list.length - 1].RowKey);
                } else {
                    this.isHaveItem = false;
                }

                this.isLoaded = true;
                this.hideLoading();
                this.cbGetListSuccess.sendCallback();
            }).catch(err => {
                this.isLoaded = true;
                this.hideLoading();
                this.cbApiResponseError.sendCallback(err);
            });
    };
    this.loadMore = function () {
        if (!this.isHaveMore && !this.isLoading) return;

        this.getList();
    };
    //util
    this.changeMonth = function (year, month) {
        this.resetList();
        this.listConfigBuilder = this.listConfigBuilder.setMonth(year, month);
        this.getList();
    };
    this.resetList = function () {
        this.list = [];
        this.isHaveItem = false;
        this.isHaveMore = true;
        this.listConfigBuilder = this.listConfigBuilder
                            .setLastRowKey(null)
                            .setMonth();
    };
    //#region loading
    this.showLoading = function () {
        if (this.isLoading) return true;
        this.isLoading = true;

        this.modalController.loadingModal.show();
    };
    this.hideLoading = function () {
        this.isLoading = false;
        this.modalController.loadingModal.hide();
    };
    //#endregion
}
